var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemH3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M13.667 19V5h-2.78v5.5H4.76V5H2v14h2.761v-5.898h6.125V19zm4.666 0c2.028 0 3.334-1.176 3.334-2.845a2.29 2.29 0 0 0-1.978-2.322c.938-.189 1.85-.987 1.85-2.206C21.54 10.016 20.324 9 18.347 9c-1.483 0-2.548.653-3.232 1.538l.9 1.292c.596-.653 1.33-1.001 2.155-1.001.874 0 1.571.377 1.571 1.146 0 .712-.634 1.03-1.571 1.03-.317 0-.9 0-1.052-.014v1.858c.126-.014.697-.029 1.052-.029 1.178 0 1.698.348 1.698 1.118 0 .725-.57 1.233-1.597 1.233a3.12 3.12 0 0 1-2.32-1.103L15 17.447c.621.87 1.787 1.553 3.333 1.553"
})));
export default SvgGemH3;